module.exports = __webpack_public_path__ + "media/images/thirsty_pretzels_logo-b8348f169a029c08ea2cdb20b8b27af3.png";